import { LOCALES } from "../locales";

export const spanish_messages = {
  [LOCALES.SPANISH]: {
    //Mobile Login Screen Text
    mobileLoginScreenTitle: "Estimado usuario",
    mobileLoginScreenText: "Para tener la mejor experiencia, debes acceder a MyDNA desde una computadora o notebook.",

    //MenuHeader
    homepage: "Inicio",
    vacancies: "Vacantes",

    //HomePagePersonal
    workAs: "Trabajo como",
    areasInterest: "Áreas de Interés",
    selectArea: "Seleccionar Área",
    myResume: "Mi Resumen",
    showVacancies: "Ver Vacantes",
    salaryConsult: "Consulta Salarial",

    //Presentation
    presentationTitle: "Presentación",
    presentationDesc:
      "Arma un lindo RESUMEN de ti para que todos te conozcan rápidamente, escríbelo y grábate contándonos de ti ! Además, puedes subir estas reseña a tus redes sociales y junto a el video de auto-presentación, donde puedes hablar de ti y tus logros, es una de las mejores maneras de que conozcan sobre ti.",
    aboutYou: "Acerca de Tí",
    writePresentationPH: "Ingrese un texto de Presentación",
    socialMedia: "Redes Sociales",
    instagramLink: "Ingres tu link de Instagram",
    linkedinLink: "Ingres tu link de LinkedIn",
    facebookLink: "Ingres tu link de Facebook",
    uploadVideoLink: "Subir url Vídeo",
    uploadLetterPresentation: "Subir Carta de Presentación",
    uploadFileDesc: "Click para adicionar o arrastre aquí",
    yourFile: "Su Archivo",
    yourFileTitle: "Decargue su documento actual",
    yourFileDownload: "Descargar",
    videoPresentation: "Vídeo de Presentación",

    //SMTM
    smtmTitle: "Por SMTM, Part of MyDNA",
    smtmDesc: "Conoce tu Salario con Show Me The Money",
    smtmText1:
      " Seguramente más de alguna vez te preguntaste si tu salario esta alineado a lo que el mercado ofrece. ¿Cómo podrías saber esta respuesta? Show Me The Money, en conjunto con MyDNA se desarrolló para responder esta pregunta de la forma más rápida y pragmática, por medio de reportes a tu medida que se actualizan en tiempo real.",
    smtmText2: "Nuestras fuentes de datos:",
    smtmText3: "* Entrevistas de trabajo realizados por Headhunters parter de MyDNA en cada país.",
    smtmText4:
      "* Números registrados en Show Me The Money, que posteriormente son validados por nuestros especialistas antes de entrar a la base de datos, garantizando la calidad de la información.",
    smtmText5: "* Aplicación de RPA para realizar la extracción de datos salariales de mercado de forma automatizada",
    smtmText6: "¿Qué esperas para conocer tu valor de mercado?",
    smtmBtn: "Generar Reporte Salarial",

    //Genes
    genesDesc: "La Solución digital que te guía en tu proceso de Reinserción Laboral",
    genesText1:
      "Mydna Outplacement es un programa laboral digital - con un importante toque humano - que apoya al profesional al momento de hacer una transición exitosa o desarrollar su carrera.",
    genesText2: "* Plan personalizado de acuerdo a las necesidades del profesional, mezclando Plataforma Digital con apoyo de Especialistas en el mercado laboral.",
    genesText3: "* Las personas que hacen su programa de Outplacement con MyDNA, encuentran un nuevo desafío Laboral hasta en un 50% del tiempo promedio para su perfil.",
    genesBtn: "Realizar prueba Gratis",

    //Jobs
    relatedJobs: "Vacantes Relacionadas",
    relatedJobsDesc:
      "Nuestros Robots trabajan 24x7 mapeando vacantes abiertas en el mercado para que puedas aplicar a nuevos desafíos profesionales. Centralizamos miles de jobs acá, donde puedes buscar a través de filtros. Al aplicar, automáticamente las empresas ya van a saber de tu interés por esta oportunidad! ¡Te deseamos mucho éxito en los procesos!",
    searchInputJobsPH: "Buscar por nombre o Id de la vacante",
    searchWithFilterText: "Buscar con filtro",
    showAllJobs: "Ver todo",
    jobsOportunityText: "oportunidades de vacantes",
    applyToJobBnt: "Postular",
    removeApplyBtn: "Remover Postulación",

    //FormationExperience
    formationDesc: "Acá debes crear y rellenar tus últimas experiencias profesionales, enfocándote en Funciones y Logros de cada periodo, recuerda ser claro, preciso y tangible.",

    // Education
    educationDesc: "Cuéntanos sobre tu formación académica, que tipo de aprendizaje tuviste, en que Institución y durante que periodos.",
    //loading
    loadingP1: "car",
    loadingP2: "gando",

    //defaultLevel
    nullLevel: "Nulo",
    basicLevel: "Básico",
    intermediaryLevel: "Intermedio",
    advancedLevel: "Avanzado",
    fluentLevel: "Fluido",

    //Buttons
    saveButton: "Guardar",
    closeButton: "Cerrar",
    backButton: "Volver",
    nextButton: "Siguiente",
    createButton: "Crear",
    accessButton: "Acceder",
    performTest: "REALIZAR TEST",
    showResult: "VER RESULTADO",
    deleteButton: "Eliminar",
    cancelButton: "Cancelar",
    yesText: "Si",
    noText: "No",
    selectOption0: "Seleccionar...",
    clickHere: "Haz click aquí",

    //Modal
    confirmDelete: "Confirmar la eliminación",

    //FormattedMessages
    country: "Pais",
    industry: "Industria",
    area: "Area",
    role: "Cargo",
    professionalResponsableTitle: "Asignar Profesional Responsable",
    complaintDetail: "Detalla tu denuncia",

    //EmptyInfo
    incompleteTest: "El colaborador todavía no ha rellenado su información",
    incompleteProfile: "El colaborador todavía no ha completado su perfil",
    emptyDesempeno: "Todavia no hay una evaluación disponíble.",

    //Login Screen
    textLogin: "Iniciar sesión con su dirección de correo electrónico",
    createAccount: "Crear nueva cuenta",
    login: "Iniciar Sesión",
    errorUserPass: "Nombre de Usuario o Contraseña incorrecta!",
    passPH: "Contraseña",

    //Card Content
    customerRating: "Evaluación de los Clientes",

    //Header
    mainMenuFeed: "Mi Feed",
    mainMenuProfile: "Mi Perfil",
    mainMenuMoment: "Mi Momento",
    mainMenuVacancies: "Mis Vacantes",
    mainMenuCompany: "Para Empresas",
    mainMenuSearch: "Buscar personas y empresas",
    mainMenuSeeMore: "Ver más",
    dropdownCompany: "Mi Compañia",
    dropdownLogout: "Salir",
    dropdownProfile: "Editar Perfil",
    searchByName: "Buscar por Nombre",

    // Body Card Text
    textServices: "Servicios de ",
    textCertified: " certificados por MyDNA",
    ourProducts: "Nuestros Productos:",
    customerEvaluation: "Evaluación de los Clientes",
    myPartnes: "Partnes",

    /** WheelCompany & Menus */
    seeMore: "Ver más",
    myBusiness: "Mi Empresa",
    peopleAnalytics: "People Analytics",
    myCollaborators: "Mis Colaboradores",
    collaboratorsRegister: "Registro de Colaborador",
    massiveRegister: "Registro Masivo",
    mySolutions: "Mis Soluciones",

    onBoarding: "Onboarding",
    knowBadgeHeroes: "Conoce Badge Heroes",
    onBoardingRegister: "Registrar Onboarding",

    trainingAndDevelopment: "Entrenamiento & Desarrollo",
    manageTrainings: "Gestionar Capacitaciones",
    workoutsMydna: "Entrenamientos by MyDNA",
    ebooksAndContent: "Ebooks & Contenidos",

    climeAndCulture: "Clima & Cultura",
    culture: "Cultura",
    cultureSurvey: "Encuesta de Cultura",
    cultureSurveyText:
      "La evaluación de cultura entrega tres informaciones fundamentales: cuál es tu cultura, cuál es la de la empresa y por ende, cuál es el match entre ambos. Haz click en el botón y selecciona las mejores respuestas!",
    climeSurvey: "Encuesta de Clima",
    climeSurveyText:
      "Haz escuchar tu voz! Aquí podrás transmitir a tu empresa cuál es tu percepción acerca del clima que se respira en la organización. Será entretenido, gratificante y te llevará pocos minutos, además de generar mucho valor para todos - tu en primer lugar. Haz click en el botón y deja tu opinión!",
    nps: "NPS",
    businessCulture: "Cultura Empresa",

    questionCulture: "Preguntas de Cultura",
    questionCarrer: "Preguntas de Carrera",
    questionLeader: "Preguntas de Liderazgo",
    questionInterests: "Preguntas de Interéses",

    performanceAnalysis: "Análisis de Desempeño",
    performanceEvaluation: "Evaluación de Desempeño",

    salariesAndBenefits: "Salario & Beneficios",
    unitReport: "Reporte Unitario",
    goPaybalance: "ir a Paybalance",
    knowPaybalance: "Conoce Paybalance",

    professionalDevelopment: "Assessement Center",
    skillTest: "Test de Competencias",
    knowMyco: "Conoce Myco",
    motivacionalTest: "Test de Motivaciones",
    englishLevelTest: "Test de Nivel de Inglés",

    careerPlan: "Plan de Carrera",
    presentacion: "Presentación",
    referencias: "Referencias",
    careerProjection: "Proyección de Carrera",
    jobDescriptor: "Descriptores de Cargo",
    vacancies: "Vacantes",

    ombudsman: "Ombudsman",

    outplacement: "Plan de Salida",
    knowGenes: "Conoce Genes",
    realocation: "Outplacement",
    leaveSearch: "Encuesta Salida",
    posicionesTitle: "Salarios por Colaborador",
    benefits: "Beneficios",
    emotionalSalary: "Salario Emocional",

    salaryProjection: "Proyección Salarial",

    apresentationDown: "Descargar Presentación",
    activeService: "Activar Servicio",

    //WheelCollaborator
    professionalHistoric: "Histórico Profesional",
    purpose: "Propósito",
    formation: "Formación",
    culture: "Cultura",
    salary: "Salario",
    habilities: "Competencias",
    motivacions: "Motivaciones",
    performance: "Desempeño",
    training: "Conocimientos",
    aData: "a la fecha",
    functionsTitle: "Funciones",
    achievementsTitle: "Logros y Conquistas",
    currentJobTitle: "Trabajo actual",
    functionsDescriptions: "Describe aquí tus funciones",
    achievementsDescriptions: "Describe aquí tus logros",
    editProfile: "Editar Perfil",
    salarySurvey: "Encuesta Salarial",
    outplacement: "Outplacement Digital",
    jobs: "Vacantes",
    myResume: "Mi Resumen",

    //Professional Historic
    collaboratorTrajectory: "Trayectória del Colaborador",
    experienceTime: "Tiempo de Experiencia",
    yearsAnd: "Años y",
    months: "Meses",
    workedIndustries: "Industrias en que ha Trabajado",
    workedPositions: "Cargos Ocupados",

    //Salary
    salaryDesc:
      "Esta información es Confidencial! Ayúdanos a entender tu paquete actual y una idea de pretensión en un nuevo desafío, así los reclutadores pueden tener esta información en su proceso.",
    lastSalaryAdjust: "Último Adjuste Salarial",
    salaryExpectation: "Expectativa Salarial",

    //References
    referencesTitle: "Referencias",
    referencesText:
      "Siempre es importante saber que piensa de ti la gente que trabajó contigo! Pídeles un testimonio en video o texto y déjalo registrado acá, esta opinión es muy importante!",
    addReferenceBtn: "Adicionar Referencia",
    emptyReference: "Todavía no has registrado las referencias.",

    //AddReference
    namePersona: "Nombre de la Persona",
    namePersonaPH: "Nombre y Apellido",
    function: "Cargo",
    companyWorkTogetherPH: "Empresa que trabajaron juntos",
    workRelation: "Relación de trabajo",
    workRelation1: "Par",
    workRelation2: "Equipo",
    workRelation3: "Jefe",
    workRelation4: "Ninguna",
    phoneReference: "Teléfono",
    emailReference: "Correo",
    recomendationLetter: "Carta de Recomención",
    recomendationVideo: "Video de Referencia",
    videoTextReference: "¿Tienes un video de tu referencia hablando de cómo es trabajar contigo? Ingresa la url del video aquí.",

    //Proposito
    purposeToWork: "Los Propósitos laborales son",

    //Formation
    education: "Educación",
    englishLevel: "Nivel de Inglés",

    //English Line Level
    //English Line Level
    englishNulo: "Nulo",
    englishBasic: "Básico",
    englishIntermedio: "Intermedio",
    englishAvanzado: "Avanzado",
    englishFlued: "Fluido",

    //Culture
    commercial: "Comercial",
    commercialText:
      "Se alinea mejor en empresas con las siguientes características : Orientación a lograr resultados. Ambiente motiva en parte a colaboradores a cumplir metas. Estilo de liderazgo motiva, pero se puede poner mas agresividad comercial. Existe competitividad en el equipo, pero se puede mejorar. Se establece relaciones con clientes pero no siempre a largo plazo. Se observa en el equipo una mayor satisfacción por ganar y captar mercado. Existen desafíos por crecer pero se puede ser más ambicioso.",
    disruptive: "Disruptiva",
    disruptiveText:
      "Se alinea mejor en empresas con las siguientes características : Estilo de organización más innovadora, se escucha y se trabaja más en equipo. Se planifica más a largo plazo. El liderazgo es más motivador, de tomar riesgos, más emprendedor. Los equipos comienzan a ser más visionarios y a tener más hambre de salir de la caja. Se tiene mayor tolerancia a la diversidad y diferencias entre equipos. La expresión libertad de hacer comienza a escucharse más.",
    collaborative: "Colaborativa",
    collaborativeText:
      "Se alinea mejor en empresas con las siguientes características : Estilo de organización levemente estructurado. Se cuenta con una estructura piramidal, donde las decisiones son tomadas por pocos. La comunicación de las decisiones o estrategia es lenta, conocida por pocos y generalmente jefaturas. Se dispone de algunos protocolos y procedimientos. Se busca estabilidad y permanencia en el tiempo. La eficiencia es un pilar para la toma de decisiones",
    traditional: "Tradicional",
    traditionalText:
      "Se alinea mejor en empresas con las siguientes características : Estilo de organización con foco en las personas. Preocupados de generar un ambiente de trabajo grato y cercano. El desarrollo profesional es parte de los desafíos permanentes. Liderazgo incentivando el trabajo en equipo. Existe alta comunicación entre jefaturas y colaboradores. La estrategia es conocida por todos. Equipos alineados y comprometidos con la empresa.",
    culturePreview: "tiene el siguiente perfil cultural",

    //Salario
    actualSalary: "Salario Actual",
    fixedSalary: "Fijo Mensual",
    variableAnualSalary: "Variable Anual",
    titlePosiciones: "Salarios por Colaborador",

    //Career Plan
    hierarchicalLevel: "Nivel Jerárquico",
    nextLevel: "Siguinte Nivel (recomendado)",
    actualLevel: "Nivel Actual -",
    possibleAreas: "Posibilidades de Cambios de Areas",
    collaboratorTextP1: "Colaboradores con experiencia en el area de",
    collaboratorTextP2: "pueden poseer conocimiento e habilidades para trabajar en el area de",
    director: "Director",
    manager: "Gerente",
    submanager: "Subgerente",
    boss: "Jefe",
    specialist: "Especialista",
    analist: "Analista",
    technical: "Operário / Técnico / Asist.",

    //Onboarding
    collStatus: "En Progreso",
    assignStatus1: "Tiene",
    assignStatus2: "assigned",
    collEmpty: "No hay ningun colaborador registrado, registra tus colaboradores para empezar",
    responsable: "Responsable",
    registerResponsable: "REGISTRAR NUEVO RESPONSABLE",
    registerCollaborator: "REGISTRAR NUEVO COLABORADOR",

    onboardingAlertAnswer: "No hay respuestas",

    statusOnboardingQuestion1: "Segue en Onboarding?",
    statusOnboardingQuestion2: "Qué le parece el proceso?",
    statusOnboardingQuestion3: "Cuántos pasos se han dado?",
    statusOnboardingQuestion4: "Está activo en el programa?",
    statusOnboardingQuestion5: "Cuánto tiempo dura el Onboarding?",
    statusOnboardingQuestion6: "Cree que el programa Onboarding está ayudando?",
    statusOnboardingQuestion7: "Progreso general del programa",

    statusOnboardingAnswerYes: "Sí",
    statusOnboardingAnswerNo: "No",

    //Capacitations
    capacitationTitle: "Entrenamientos",
    capacitationCol: "Capacitacione",
    capacitationAreaCol: "Área",
    capacitationProgress: "Progresso",
    capacitationsTitle: "Capacitaciones",
    capactitationSearchPlaceHolder: "Buscar curso por nombre e palabra clave",
    capacitationChooseArea: "Elija el área de la capacitación",
    newCourse: "Crear Nuevo Curso",
    capacitationCourse: "Cursos",
    capacitationArea: "Area",
    capacitationEmpty: "No hay capacitación registrada",

    //Trainnings
    trainningTitle: "Entrenamientos by Mydna",
    //Trainning List
    //English
    trainningCardTitleEnglish: "Clases Inglés",
    trainningCardTextEnglish: "Aprendizaje de Inglés para tus colaboradores.",
    //Comercial & Selling
    trainningCardTitleComercialSelling: "Entrenamiento Pitch Comercial & Ventas",
    trainningCardTextComercialSelling: "Entrenamiento de Pith Comercial para tus colaboradores.",
    //Gamefied Trainning
    trainningCardTitleGamefied: "Herramienta de Entrenamiento Gamificado",
    trainningCardTextGamefied: "Construye tu propia capacitación personalizada. Entregamos una experiencia totalmente gamificada a sus colaboradores.",

    //Empy Content Book
    empyContentText: "Todavia no hay contenidos para mostrar",

    //DashBoard Clime
    dashboardClimeTitle: "DashBoard - Pesquisa de Clima",
    emptyInformationClime: "Aun no se han contestado encuestas de clima",
    textInformationBusinessCulture: "Tener candidatos alineados a la cultura de tu empresa mejora la felicidad del colaborador, disminuyendo la rotación.",
    textInformationBusinessCulture2: " Responde las preguntas de cultura, carrera, liderazgo e intereses y conocerás cuál es la cultura empresarial de tu empresa.",

    //BusinessCultureQuestions
    //Cultural
    businessCulturalQ1: "Somos reconocidos por la forma en que reciclamos, cuidamos el medioambiente y hacemos uso inteligente de los recursos",
    businessCulturalQ2: "Nos vestimos y expresamos generalmente de manera formal",
    businessCulturalQ3: "Tenemos 50% hombres y 50% mujeres en posiciones de primera línea de liderazgo",
    businessCulturalQ4: "Tenemos Directores y/o altos ejecutivos abiertamente homosexuales",
    businessCulturalQ5: "Somos reconocidos como una organización altamente innovadora",
    businessCulturalQ6: "Tenemos telefonos y mails para que los empleados puedan hacer denuncias de manera confidencial",

    //Career
    businessCareerQ1: "Para ser exitoso aquí, tienes que ser competitivo",
    businessCareerQ2: "Buscamos personas que valoren más su desarrollo profesional que tener una recompensa económica alta",
    businessCareerQ3: "Con un alto desempeño, las personas van asumiendo posiciones de poder rápidamente (cada 2 años una promoción)",
    businessCareerQ4: "Para ser exitoso aquí, debes ser políticamente correcto en la forma de plantear tus puntos de vista",
    businessCareerQ5: "El uso de tatuajes, aros o tu apariencia física puede hacerte un poco más difícil llegar a cargos de alto nivel",
    businessCareerQ6: "Tener conversaciones de desarrollo de carrera con los empleados no es prioridad en este momento",

    //Leader
    businessLeaderQ1: "Nuestros cargos directivos o gerenciales tienen estacionamientos privilegiados o especiales",
    businessLeaderQ2: "Si estamos bajo presión, la comunicación en ocasiones puede tornarse más dura",
    businessLeaderQ3: "Nuestro Gerente General y Directorio no es reconocido por ser cercano a las personas",
    businessLeaderQ4: "El liderazgo es el tema más importante en nuestra estrategia corporativa",
    businessLeaderQ5: "Nuestros equipos son tan apasionados que a veces trabajan más horas de lo habitual",
    businessLeaderQ6: "Es parte de nuestra cultura que los jefes pidan feedback a sus equipos sobre cómo mejorar su liderazgo y gestión",

    //Interests
    businessInterestsQ1: "Los sindicatos son un actor clave para escuchar a los colaboradores",
    businessInterestsQ2: "Damos flex time (elegir el horario de entrada y salida)",
    businessInterestsQ3: "Damos viernes corto (salir más temprano los viernes)",
    businessInterestsQ4: "Damos días libres por sobre lo legal si nuestros empleados se casan o contraen un Acuerdo de Union Civil",
    businessInterestsQ5: "Somos reconocidos por dar mejores beneficios que los del mercado para mujeres en pre y post natal",
    businessInterestsQ6: "Apoyamos a las comunidades deportivas de los colaboradores",

    //Promoter Score
    netPromoteScoreTitle: "Net Promote Score",
    detractorTitle: "Detratores",
    detractorText:
      "Los que no están satisfechos. Cualquiera que no localifique arriba probablemente tenga algo de qué quejarse. Además, incluso suelen hablar mal de la empresa a sus contactos. Sin mencionar que no son fieles, en cualquier momento definitivamente pueden abandonar la empresa.",
    neutralTitle: "Neutros",
    neutralText:
      "No pueden considerarse insatisfechos, pero no hay garantía de que sean leales. Probablemente tengan algún punto que mejorar, pero eso no quiere decir que quieran o piensen en abandonar la empresa. Al mismo tiempo, no son perfectamente leales, lo que puede convertirlos en detractores, si algo sucede o se dan cuenta de que pueden obtener algo mejor en otro lugar.",
    promotorTitle: "Promotores",
    promotorText: " Son aquellos más fieles, con tendencia a recomendar la empresa. Aunque el grado 9 indica que algo puede mejorar, no compromete la lealtad.",

    //Culture Business
    businessCultureTitle: "Cultura Empresa",
    asksTimelineText: "Marca lo que quieres en tu vida laboral y lo que piensas sobre tu empresa última/actua",
    //Timeline
    cbTimelineStart: "Inicio",
    cbTimeLineQuestions: "Preguntas de Cultura",
    cbTimeLineCareer: "Preguntas de Carrera",
    cbTimeLineLeader: "Preguntas de Liderazgo",
    cbTimeLineInterests: "Preguntas de Intereses",
    cbTimeLineReportDelivery: "Entrega del Reporte",

    //TimeLine Finished
    cbTimeLineAswer: "Tu Cultura Empresarial es",
    cbTimeLineComercial: "Comercial",
    cbTimeLineComercialDesc:
      "Orientación a lograr resultados. Ambiente motiva en parte a colaboradores a cumplir metas. Se puede mejorar. Estilo de liderazgo motiva, pero se puede poner mas agresividad comercial. Existe competitividad en el equipo, pero se puede mejorar. Se establece relaciones con clientes pero no siempre a largo plazo. Se observa en el equipo una mayor satisfacción por ganar y captar mercado. Existen desafíos por crecer pero se puede ser más ambicioso.",
    cbTimeLineDisruptive: "Distuptiva",
    cbTimeLineDisruptiveDec:
      "Estilo de organización más innovadora, se escucha y se trabaja más en equipo. Se planifica más a largo plazo. El liderazgo es más motivador, de tomar riesgos, más emprendedor. Los equipos comienzan a ser más visionarios y a tener más hambre de salir de la caja. Se tiene mayor tolerancia a la diversidad y diferencias entre equipos. La expresión 'libertad de hacer' comienza a escucharse más.",
    cbTimeLineColaborate: "Colaborativa",
    cbTimeLineColaborateDesc:
      "Estilo de organización con foco en las personas. Preocupados de generar un ambiente de trabajo grato y cercano. El desarrollo profesional es parte de los desafíos permanentes. Liderazgo incentivando el trabajo en equipo. Existe alta comunicación entre jefaturas y colaboradores. La estrategia es conocida por todos. Equipos alineados y comprometidos con la empresa.",
    cbTimeLineTraditional: "Tradicional",
    cbTimeLineTraditionalDesc:
      "Estilo de organización levemente estructurado. Se cuenta con una estructura piramidal, donde las decisiones son tomadas por pocos. La comunicación de las decisiones o estrategia es lenta, conocida por pocos y generalmente jefaturas. Se dispone de algunos protocolos y procedimientos. Se busca estabilidad y permanencia en el tiempo. La eficiencia es un pilar para la toma de decisiones.",

    //EmployerPerformance
    employerPerformanceTitle: "Evaluación de Desempeño",
    employersShowCollumTitle: "Colaboradores",
    employerCriterionCollumTitle: "Criterio",
    employerWeigthCollumTitle: "Peso",
    employerExecutedCollumTitle: "% Logrado",

    //ShowMeTheMoney
    salaryConsultTitle: "Consultoria Salarial Personalizada",
    salaryConsultText: "Completa la siguiente información y te entregaremos un reporte hecho a la medida de los salarios de tu colaboradores.",
    salaryConsultErrorEmptyFields: "ERROR! Asegúrese de que todos los campos estén llenos.",
    salaryConsultErrorIncompatibleSalary: "ERROR! Salario incompatible con el puesto.",
    salaryConsultSuccessful: "Reporte enviado, revisa tu email!",
    salaryConsultResponsableName: "Nombre del Responsable que Recibirá el Reporte Salarial",
    salaryConultResponsableEmail: "Mail del Responsable",
    salaryConsultEducationLevel: "Nivel del Estudio",
    salaryConsultExperienceYears: "Años de Experiencia en la Posición",
    salaryConsultExperienceThreeLess: "Menos de 3 años",
    salaryConsultExperienceThreeOrSeven: "Entre 3 y 7 años",
    salaryConsultExperienceSevenOrMore: "Más de 7 años",
    salaryConsultEnglishLevel: "Nivel del Inglés",
    salaryConsultEnglishAloof: "Indiferente",
    salaryConsultEnglishBasic: "Básico",
    salaryConsultEnglishMid: "Intermédio",
    salaryConsultEnglishHigh: "Avanzado",
    salaryConsultGrossMonthly: "Salario Bruto Mensual",
    salaryConsultAnnualBonus: "Bonus Anuales",
    salaryConsultButtonSend: "Enviar informe al correo",

    //Jobs Description
    jobsDescriptionTitle: "Descriptores de Cargo",
    jobsDescriptionShowMore: "Ver descripción",
    jobsDescriptionReturn: "Volver a la  lista de cargos",
    jobsDescriptionTitleJob: "Qué hace un ",
    jobsDescriptionActivies: "Cuáles son sus principales actividades",
    jobsDescriptionFormation: "Perfil Técnico / Experiencia / Formación Académica",
    jobsDescriptionPersonal: "Perfil Personal",
    jobsDescriptionRelacion: "Nivel de Relación",
    jobsDescriptionLanguage: "Idioma",
    jobsDescriptionStudy: "Estudio",

    //CareerPlan Section
    careerPlanText: "Quiero un profesional apto a ocupar el cargo de:",
    careerPlanPHRole: "ej: Jefe",
    careerPlanPHArea: "ej: Comercial",
    careerPlanBtnSearch: "Buscar",
    careerPlanBtnClean: "Limpiar",
    careerPlanPHNameColaborator: "Nombre del Colaborador",
    careerPlanNextLevel: "Proximo Nivel",
    careerPlanSameAreas: "Áreas Afines",

    //SearchDashBoard
    leaveSearchTitle: "Encuesta de Salida",
    leaveSearchNotFound: "La encuesta de Salida todavía no ha sido respondida por ningun colaborador",

    //AddEmployer
    assignCollaborator: "Agregar Colaboradores",
    collaboratorTitle: "Colaborador",
    nullEmployersRegister: "No hay empleados registrados",

    //NewClass
    createNewClass: "Crear Nuevo Curso",
    className: "Nombre del Curso",
    classLink: "Link del Curso",
    courseDescription: "Descripción",

    //Denuncia
    complaintSecurityText: "Usted está en un espacio seguro",
    complaintSecuryTextBody: "Este es un canal totalmente confidencial entre usted y MyDNA. Intentaremos ayudarle sin revelar sus datos.",
    btnComplaint: "Crear Denuncia",
    complaintTypes: "Tipos de Asedio",
    complaintGenerate: "Generar proceso para enviar denuncia",
    complaintOptionA: "Discriminación laboral del trabajador.",
    complaintOptionB: "Culpabilizar al trabajador.",
    complaintOptionC: "Aislamiento laboral.",
    complaintOptionD: "Faltas de respeto en el trabajo e insultos.",
    complaintOptionE: "Respecto a las tareas asignadas.",
    complaintOptionF: "Difamación profesional y/o personal.",
    complaintOptionG: "Sobrecarga de trabajo.",
    complaintOptionH: "Acoso sexual",
    complaintOptionI: "Rebajar las funciones del trabajador.",
    complaintOptionJ: "Burnout",
    complaintOptionK: "Maltrato laboral.",
    complaintOptionL: "Otro (Especifique)",

    // CardSection Title
    collaborator360: "Colaborador 360°",
    dashboardCompany: "Dashboard Empresa",
    executiveSearch: "Executive Search",
    middleTopManagement: "Middle & Top Management",
    backoffandStaff: "Backoff & Staff",
    plataformOnboardinGamified: "Plataforma de Onboarding Gamificado",
    englishClass: "Clases de Inglés",
    commercialTraining: "Entrenamiento Pitch Comercial & Ventas",
    gamefiedTraining: "Herramienta de Entrenamiento Gamificado",
    cultureReport: "Reporte de Cultura",
    culturalFitEmp: "Fit Cultural Candidados",
    culturalFitCol: "Fit Cultural Colaboradores",
    culturalTransformation: "Transformación Cultural",
    realTimeConsult: "Consulta en Tiempo Real",
    customStudy: "Estudio Personalizado",
    variableSalary: "Estudio Remuneración Variable",
    salaryGuide: "Guía Salarial",
    topManagement: "Top Management",
    middleManagement: "Middle Managment",
    backofficeOutput: "Backoffice & Staff (Salida)",
    searchOutput: "Encuesta de Salida",

    //

    //CardSection Text
    textCollaborator360: "El People Analiytcs más completo con indicadores clave para la gestión de los talentos de tu organización.",
    textDashboardCompany:
      "KPIS claves para la gestión de talentos de tu organización. Conoce dónde la empresa vá bien y dónde hay trabajo para mejorar con KPIS claros y bien definidos.",
    textExecutiveSearch:
      "Headhunting especializado en alta y mediana gerencia con presencia regional. Asegura la contratacción de profesionales que se ajustan al perfil de su empresa, logrando un mayor nivel de compromiso y un menor nivel de rotación.",
    textMiddleTopManagement:
      "Reclutamiento para cargos intermedios en la pirámide de forma rápida y precisa. Se buscan profesionales que se ajustan al perfil de su empresa, asegurando un mayor nivel de compromiso y un menor nivel de rotación.",
    textBackoffandStaff:
      "Reclutamiento para cargos operativos y técnicos de forma rápida y precisa. Se buscan profesionales que se ajustan al perfil de su empresa asegurando un mayor nivel de compromiso y un menor nivel de rotación.",
    textPlataformOnboardinGamified:
      "Mejora el compromiso y acelera el desarrollo de tus trabajadores con un software de gamificación que genera interacción, educación, cultura y trabajo en equipo.",
    textEnglishClass: "Aprendizaje de Inglés para tus colaboradores.",
    textCommercialTraining: "Entrenamiento de Pith Comercial para tus colaboradores.",
    textGamefiedTraining:
      "Construye tu propia capacitación personalizada. Entregamos una experiencia totalmente gamificada a sus colaboradores con contenidos de capacitación seleccionados por ti.",
    textCultureReport: "Conoce la cultura de tu organización y compara la visión de la empresa versus la de sus colaboradores.",
    textCulturalFitEmp: "Conoce el % de fit que tiene la organización con sus colaboradores en relación a su propósito y cultura.",
    textCulturalFitCol: "Conoce el % de fit que tiene la organización con sus candidatos en relación a su propósito y cultura.",
    textCulturalTransformation: "¿Dónde estás hoy y dónde quieres llegar? En caso de que la cultura actual de tu empresa no refleja lo que te gustaria, te ayudamos.",
    textPerformanceAnalysis:
      "Evalua el desempeño de sus colaboradores, conoce los gaps y fortalezas de sus equipos .Define la mejor estrategia de gestión de talentos con datos claros y cuantitativos.",
    textRealTimeConsult:
      "Accede a la base de datos salariales de Mydna con información actualizada de mercado para definir la mejor estrategia para tu organización. Consulta por tipo de empresa, cargo, experiencia y  competencias.",
    textCustomStudio:
      'Para aquellos cargos que todavia no encuentras información en nuestra plataforma en el área de "consulta en tiempo real", te apoyamos en levantar información de forma ágil y asesorada por nuestro equipos de especlialistas.',
    textVariableSalary: "Define la mejor estrategia de remuneración variable para tu organización junto a una evaluación de desempeño.",
    textSalaryGuide: "Descarga la última Guia Salarial desarrollada por PayBalance/Mydna",
    textMotivacionalTest: "Test psicolaboral de motivaciones profesionales para conocer lo que realmente motiva a tus colaboradores y/o candidatos.",
    textSkillTest: "Test psicolaboral de habilidades profesionales para conocer las habilidades blandas que más de destacan a tus colaboradores y/o candidatos.",
    textEnglishLevel: "Evalua el nivel de inglés de tus colaboradores con el apoyo de Nulinga. Un test de 20 minutos para conocer su dominio del idioma.",
    textCareerProjection: "Define cuál es el próximo cargo de los profesionales de acuerdo a sus habilidades, competencias, motivaciones y aspiraciones.",
    textSalaryProjection: "Conoce cuánto pagar en el caso de ascender a un profesional aplicando las mejores estrategias de desarrollo profesional y retención.",
    textJobDescriptor: "Conoce las comptencias necesarias y responsabilidades de cada cargo.",
    textTopManagement: "Asesoramiento para la recolocación de un profesional especializado en alta y mediana gerencia.",
    textMiddleManagement:
      "Acceso a la plataforma de outplacement digital especializada en los cargos intermedios de la pirámide para una recolocación rápida en el mercado laboral.",
    textBackofficeOutput: "Acceso a la plataforma de outplacement digital especializada en cargos operarios y técnicos para una recolocación rápida en el mercado de trabajo.",
    textSearchOutput: "Conoce la experiencia de sus ex colaboradores en el momento de su salida",
    textGenesCard: "Asesoramiento para la recolocación de un profesional",

    // PeopleAnalytics Session
    //MyCollaborators
    myCollaboratorsTitle: "Mis Colaboradores",
    searchCollaborator: "Buscar un Colaborador",
    notDoneCultureSearch: "Este colaborador aún no ha contestado la encuesta de cultura",
    noCollaboratorsRegistered: "Todavia no hay colaboradores registrados",

    //CollaboratoRegister
    collaboratorName: "Nombre",
    collaboratorEmail: "E-mail",
    loadCollaborator: "Cargar Colaborador",
    //MassiveRegister
    collBodyText: "Descarga el modelo de planilla excel, complétala con la información de tus colaboradores y luego cargala en la base.",
    collDownloadSheet: "Descargar Planilla Modelo",
    collUpSheet: "Click para elegir Archivo",
    collArchive: "Archivo",

    //BadgeHeroes
    badgeHeroesTitle: "Badge Heroes",
    badgeHeroesTextCard:
      "Mejora el compromiso y acelera el desarrollo de tus trabajadores con un software de gamificación que genera interacción, educación, cultura y trabajo en equipo.",

    //Myco
    mycoTitle: "Testes de Competencias y Motivaciones profesionales",
    mycoTextCard: "Test psicolaboral de Compentencias y motivaciones profesionales para conocer las habilidades blandas y lo que realmente motiva a tus colaboradores.",

    //ProgressBar
    progressText: "Concluido",
    progressMyProfile: "Mi Perfil",
    progressProfileText: "Seleccione la categoria que le gustaria comenzar",

    //Personal Info
    editProfileImg: "Editar foto de Perfil",
    professionalInformation: "Información Profesional",
    personalInformation: "Información Personal",
    personalCompanyCol: "Empresa",
    personalIndustryCol: "Industria",
    personalAreaCol: "Area",
    personalEntryDate: "Fecha de Ingreso",
    personalExitDate: "Fecha de Término",
    personalHastaFecha: "Hasta la fecha",
    //Education
    personalEducation: "Educación",
    personalEnglishLevel: "Nivel de Inglés:",
    personalELNulo: "Nulo",
    personalELBasic: "Básico",
    personalELAverage: "Intermedio",
    personalELAdvanced: "Avanzado",
    personalELFluent: "Fluído",
    personalUniversity: "Universidad",
    personalType: "Tipo",
    personalClass: "Curso",
    //Salary
    personalSalary: "Salario",
    personalFixBruteSalary: "Salario Fijo Actual:",
    personalCoin: "Moneda:",
    personalVariableSalary: "Salario Variable Anual:",

    //Purpose
    myPurposes: "Mis Propositos",
    yourPurpose: "Su Proposito",
    myPurposeText:
      "Comparte tus objetivos personales y profesionales, lo que te motiva a ser una persona y profesional cada día mejor. Por medio de asesoría digital, te ayudaremos a hacer de tus objetivos, realidad.",

    //Culture
    myCultureProfile: "Mi Perfil Cultural",
    myCultureText: "Conoce tu perfil cultural y las empresas en las que encajas y estarás contento, según tus preferencias profesionales.",

    //Competencias
    competenciaTitle: "Assessment Competencias:",
    abilitiesCollaboratorTitleText: "Quieres conocer tus competencias? Puedes hacerlo ya.",
    abilitiesCollaboratorTextP1: "Nuestro test evalúa 11 competencias de tu personalidad, como",
    abilitiesCollaboratorTextP2: "Visión estratégica, Liderazgo, Orientación al cliente, Trabajo en equipo,",
    abilitiesCollaboratorTextP3: " entre otros.",
    abilitiesCollaboratorTextEmail: "Te llegará un correo con el acceso al test online",
    abilitiesCollaboratorDoubtsText: "Accede nuevamente aquí para ver los resultados (pueden demorar hasta 24hrs, luego de haber completado el test)",

    //Motivacions
    motivationTitle: "Assessment Motivaciones:",
    motivacionCollaboratorTitle: "Qué es lo que te motiva? Descúbrelo ya!",
    motivacionalCollaboratorTextP1: "Nuestro test evalúa 17 factores de tu ámbito profesional que te motivan.",
    motivacionalCollaboratorTextP2: "Conocer claramente qué te mueve es fundamental para guiar tu carrera y tu vida.",
    motivacionalCollaboratorTextP3: " Haz el test ya!",

    //Performance
    performanceTitle: "Desempeño",
    perfomanceFinalResult: "Resultado Final:",

    //myKnowledge
    myKnowledgeTitle: "Mis Conocimientos",
    myKnowledgeText:
      "Cuentanos los conocimiento que has desarrollado y el valor que puedes ofrecer al mercado. Acá entran todo tipo de Curso, técnicos o no, auto-aprendizaje, etc.",
    assignKnowledge: "Agregar nuevo conocimiento",

    //Trainings
    ebooks: "E-books & Contenidos",
    myTrainings: "Mis Entrenamientos",
    createNewTraining: "Crear nueva Capacitacion",
    englishText: "Test de Inglés",
    nulingaText: "La plataforma online de aprendizaje de idiomas pensada para el mundo corporativo.",
    typeKnowledge: "Tipo de Conocimiento",
    languageTrainingTitle: "Idioma",
    otherTrainingTitle: "Otro",
    levelKnowledgeTitle: "Nivel de Conocimiento",

    //Employee Profile Edit
    profileError: "Campo requerido",

    //GoToPaybalance
    paybalanceTitle: "Ir a Paybalance",
    paybalanceDescription1: "Hola,",
    paybalanceDescription2: "Gracias por la confianza en MyDNA!",
    paybalanceDescription3: "Acá tendrás acceso a PayBalance by MyDNA, Plataforma de Información Salarial en Tiempo Real. Para eso debes hacer click en el link Abajo:",
    paybalanceDescription4: "Y entrar con tu email y clave, el mismo de MyDNA, para que puedar usar todos los Recursos de Paybalance.",
    paybalanceDescription5: "Ambos equipos de MyDNA y Paybalance iran apoyarte en esta jornada, puedes entrar en contacto con ellos en caso de dudas:",
    paybalanceTxt: "Equipo",
    paybalanceBtn: "IR A PAYBALANCE",

    //KnowPaybalance
    KnowPaybalanceTitle: "Conoce Paybalance",
    KnowPaybalanceTextCard:
      "Accede a PayBalance by Mydna con información actualizada de mercado para definir la mejor estrategia para tu organización. Consulta por tipo de empresa, cargo, experiencia y competencias.",

    //Outplacement
    outplacementAlertAnswer: "No hay respuestas",
    outplacementQuestionOne: "Ya encontró trabajo?",
    outplacementQuestionTwo: "Cómo se siente en relación al proceso?",
    outplacementQuestionThree: "Cantidad de postulaciones:",
    outplacementQuestionFour: "Está participando de entrevistas?",
    outplacementQuestionFive: "En cuanto tiempo cree encontrar nuevo trabajo?",
    outplacementQuestionSix: "Cree que el programa está ayudando en el proceso?",
    outplacementQuestionSixPos: "Cree que el programa ha ayudado al proceso?",
    outplacementQuestionSeven: "Avance en el programa Genes:",
    outplacementAnswerYes: "Sí",
    outplacementAnswerNo: "No",
    outplacementAnswerOne: "entrevista(s) en el momento",
    outplacementAnswerTwo: "No está realizando estrevistas en el momento",
    outplacementAnswerThree: "En",

    outplacementAnswerFour: "mes(es)",
    outplacementOservation: "Observación",

    //Ombudsman
    occurrences: "Ocurrencias",
    noOccurrences: "Todavia no hay ocurrencias",
    ombudmanTextOne: "Esta información es confidencial y está restringida a las personas autorizadas dentro de la compañía.",
    ombudmanTextTwo: "Para obtener la información, entra en contacto con nuestro equipo; una vez verificada tu identidad, te entregará la información.",
    ombudsmanBtn: "delivery@mydnadigital.com",

    //Campaign
    campaignTitle: "Campaña People Analytics",
    campaignTxt:
      "Luego de registrar a los colaboradores en la plataforma podrá enviar el correo, seleccionar al personal requerido y hacer clic en “ENVIAR” para realizar la entrega simultánea a las personas deseadas. Junto con esto entregaremos sus respectivos accesos a cada colaborador. En MyDNA Employee cada colaborador podrá cargar toda la información relevante para que las personas responsables por la gestión de talentos tengan a su disposición en todo momento datos como: historial profesional, educación, encuesta de clima, cultura, habilidades, entre otros.",
    campaignMenu: "Campaña Colaborador",
    campaignTableName: "Nombre",
    campaignTableMail: "Mail",
    campaignTableArea: "Área",
    campaignTableJob: "Cargo",

    //Salarios y Beneficios
    salariosTitle: "Salarios por Cargo",

    //Internal Channel
    internalChannelTitle: "Comunicación interna",
    internalChannelNewMessage: "Nuevo mensaje",
    internalChannelNoMessages1: "El buzón se encuentra vacío, crea tu primer mensaje",
    internalChannelNoMessages2: " para comenzar a comunicarte con los colaboradores",
    internalChannelSendedMessages: "Mensajes enviadas",
    internalChannelReceivedMessages: "Mensajes recebidas",

    //Internal Vacancies
    internalVacanciesTitle: "Vacantes internas",
    internalVacanciesCreate: "Crear vacantes",
    internalVacanciesActive: "Vacantes activas",

    //MYCO Test
    mycoAbilitiesQ1: "Análisis y Resolución de Problemas",
    mycoAbilitiesQ2: "Innovación",
    mycoAbilitiesQ3: "Visión Estratégica",
    mycoAbilitiesQ4: "Orientación al cliente",
    mycoAbilitiesQ5: "Liderazgo",
    mycoAbilitiesQ6: "Trabajo en Equipo",
    mycoAbilitiesQ7: "Orientación a resultados",
    mycoAbilitiesQ8: "Plan. Y Org.",
    mycoAbilitiesQ9: "Gestión del cambio",
    mycoAbilitiesQ10: "Auto desenvolvimento",
    mycoAbilitiesQ11: "Gestión del Estrés",

    mycoMotivationsQ1: "Orientación comercial",
    mycoMotivationsQ2: "Orientación al objetivo",
    mycoMotivationsQ3: "Orientación a la tipología del trabajo realizado",
    mycoMotivationsQ4: "Orientación a la innovación",
    mycoMotivationsQ5: "Aspecto Económico",
    mycoMotivationsQ6: "Autonomía y Versatilidad",
    mycoMotivationsQ7: "Seguridad",
    mycoMotivationsQ8: "Prestigio",
    mycoMotivationsQ9: "Balance Profesional",
    mycoMotivationsQ10: "Satisfacción con el puesto",
    mycoMotivationsQ11: "Compromiso",
    mycoMotivationsQ12: "Carrera",
    mycoMotivationsQ13: "Desarrollo de Competencias",
    mycoMotivationsQ14: "Proyecto Profesional",
    mycoMotivationsQ15: "Orientación a las Rel. Interpersonales",
    mycoMotivationsQ16: "Orientación Conceptual",
    mycoMotivationsQ17: "Orientación a la gestión",

    //SalaryByRole
    salaryRoleEmployee: "Colaborador",
    salaryRoleCoin: "Moneda",
    salaryRoleSalary: "Salario Mensual",
    //SeniorityLevel
    salaryRoleSL1: "Indiferente",
    salaryRoleSL2: "Junior",
    salaryRoleSL3: "Mediano",
    salaryRoleSL4: "Senior",
    //QualificationLevel
    salaryRoleQL1: "Indiferente",
    salaryRoleQL2: "Graduación",
    salaryRoleQL3: "MBA",
    salaryRoleQL4: "MBA Internacional",

    salaryRoleAlert: "Esta posición esta siendo revisada. Para descargar el reporte intente nuevamente más tarde",

    //DashboardClime&Benefits
    dashboardTextClimeBenefits: "La información presentada en el dashboard solo refleja la información de los colaboradores a los cuales  se la ha informado el salario",

    alertEmptyDashboard: "Hola! Aún no has cargado información salarial de un colaborador",

    //Benefits
    benefitsText: "Escoge el cargo y descubre los beneficios que el mercado ofrece para cada cargo",
    benefitsSearchByCountry: "País de la Posición del Colaborador",

    alimentationTitle: "Colación",
    alimentationText: "Valor promedio es de CLP $3.700 diarios",

    transportTitle: "Movilización",
    transportText: "El valor puede variar, dependiendo de la empresa y el salario base del trabajador",

    lifeInsuranceTitle: "Seguro Complementario",
    lifeInsuranceText: " Complemento del plan de salud con un promedio de cobertura de 500 UF por beneficiario",

    certificationTitle: "Certificaciones",
    certificationText: "Apoyo económico para certificar habilidades",

    vehicleTitle: "Vehículo",
    vehicleText: "Beneficio ofrecido cuando este aporta o utiliza su vehículo para desarrollar actividades relacionadas al trabajo",

    tradingPowerTitle: "% Trading Power Anual",
    tradingPowerText: "Como forma de reconocer al profesional que ayudó a que la empresa ganara valor, parte del lucro de dicho periodo es entregado al ejecutivo",

    computerTitle: "Computadora/Celular",
    computerText: "Son considerados herramientas de trabajo y su entrega es cada día más masiva",

    gymTitle: "Gimnasio",
    gymText: "Acuerdos con gimnasios que permiten descuentos al colaborador",

    anualBonusTitle: "Bono Anual por Resultados",
    anualBonusText: "El valor puede variar dependiendo del desempeño del colaborador",

    bonusTitle: "Aguinaldo",
    bonusText: "El valor puede variar de 33.000 a 300.000 CLP. Siendo la media a 60.000 CLP",

    equityTitle: "Equity",
    equityText: "La compañía ofrece a su funcionario estratégico acciones de la empresa, tornándose socio de esta",

    stockOptionsTitle: "Stock Options",
    stockOptionsText: "La compañía ofrece a su trabajador estratégico la opción de compra de acciones de la compañía a precios mejores que los ofrecidos al mercado",

    //EmotionalSalary
    emotionalSalaryText: "Escoge la temática referente al salario emocional que entrega el mercado y descubre cuales son los más comunes",
    emotionalSalaryOptionSelect: "Elije una opcion",

    //MyCompany
    companyDetails: "Detalles de la Marca",
    companyLogo: "Cargar su logotipo",
    companyName: "Nombre",
    companyDescription: "Descripción",
    companyAnualBilling: "Facturación Anual",
    companyLocation: "Localización",
    companySize: "Tamaño de la Empresa",
    companySize1: "Pequeña",
    companySize2: "Mediana",
    companySize3: "Grande",
    companyEmployeeAmount: "Numero Empleados",
    companyContact: "Dados de Contacto y Redes Sociales",
    companyPhone: "Teléfono",
    companyWebPage: "Página Web",
    companyProducts: "Productos de la Marca",
    companyAddProduct: "Agregar Producto",
    companyContent: "Contenido",
    companyUpVideos: "Sube los videos de su Empresa aquí",

    //InternalJobs
    internalJobStep1: "Area, Nivel, Tiempo de Experiencia",
    internalJobName: "Nombre del Puesto*:",
    internalJobArea: "Área(s) de Desempeño*:",
    internalJobNivel: "Elije el nivel Jerárquico*:",
    internalJobExperienceYears: "Años de experiencia requeridos para la posición*:",
    internalJobOptionArea: "Seleccione un área",
    internalJobOptionNivel: "Seleccione una opción",

    internalJobStep2: "Descripción de Cargo",
    internalJobDescription: "Descripción",
    internalJobRequeriments: "Requerimientos",

    internalJobRequerimentsPlaceHolder: "Escribe aqui los otros requerimiento y funciones del cargo",

    internalJobTitle: "Vacantes Internas",
    internalJobTableC1: "VACANTE",
    internalJobTableC2: "AREA",
    internalJobTableC3: "VER POSTULACIONES",
    internalJobSearchPlaceHolder: "Búsqueda Vacante",
    internalJobShowMore: "Carga Más...",
    internalJobEmptyJob: "No hay vacantes",
    internalJobReturn: "VOLVER A LA LISTA DE VACANTES",

    //HistoricProfessionalEE
    historicProfessionalEENameCompany: "Nombre Empresa",
    historicProfessionalEEAreaCompany: "Industria",
    historicProfessionalEEOption0: "Seleccionar...",
    historicProfessionalEEOption1: "Agroindustria",
    historicProfessionalEEOption2: "Autopartes",
    historicProfessionalEEOption3: "Bienes de Consumo",
    historicProfessionalEEOption4: "Comunicaciones",
    historicProfessionalEEOption5: "Construcción",
    historicProfessionalEEOption6: "Consultoría",
    historicProfessionalEEOption7: "Educación",
    historicProfessionalEEOption8: "Electronica",
    historicProfessionalEEOption9: "Energía",
    historicProfessionalEEOption10: "Farmacéutica",
    historicProfessionalEEOption11: "Ingeniería",
    historicProfessionalEEOption12: "Commodities",
    historicProfessionalEEOption13: "Electro / Electrónica",
    historicProfessionalEEOption14: "Logistica y Transporte",
    historicProfessionalEEOption15: "Maquinas y Equipos Industriales",
    historicProfessionalEEOption16: "Manufactura",
    historicProfessionalEEOption17: "Ocio y Entretenimiento",
    historicProfessionalEEOption18: "Publicidad",
    historicProfessionalEEOption19: "Química, Plastico y Petroquímica",
    historicProfessionalEEOption20: "Retail",
    historicProfessionalEEOption21: "Sector Público",
    historicProfessionalEEOption22: "Seguros",
    historicProfessionalEEOption23: "Telecomunicaciones",
    historicProfessionalEEOption24: "Textil",
    historicProfessionalEEOption25: "TI",
    historicProfessionalEEOption26: "Vehículos",
    historicProfessionalEEOption27: "Financieros",
    historicProfessionalEEOption28: "Salud",
    historicProfessionalEEOption29: "Veterinaria",
    historicProfessionalEEOption30: "Internet",
    historicProfessionalEEOption31: "Legal",
    historicProfessionalEEOption32: "Líneas Aereas",
    historicProfessionalEEOption33: "Minería",
    historicProfessionalEEJob: "Cargo",
    historicProfessionalEEEntryDate: "Fecha de Entrada",
    EEMonth: "Mes",
    EEYear: "Año",
    historicProfessionalEEActualJob: "Trabajo Actual",
    historicProfessionalEELeaveDate: "Fecha de Saida",
    historicProfessionalEEHierarchicalLevel: "Nível Jerarquico",
    historicProfessionalEEArea: "Área",
    professionalExperienceDesc:
      "Acá debes crear y rellenar tus últimas experiencias profesionales, enfocándote en Funciones y Logros de cada período, recuerda ser claro, preciso y tangible",

    //FormationEE
    formationEENameUniversity: "Nombre Universidad",
    formationEEType: "Tipo",
    formationEEOption1: "Técnico",
    formationEEOption2: "Grado universitario",
    formationEEOption3: "Diplomado",
    formationEEOption4: "MBA/Master",
    formationEEOption5: "Doctorado",
    formationEECourse: "Carrera",
    formationEEEntryDateCourse: "Fecha de Ingreso",
    formationEECurrentlyStuding: "Cursando Actualmente",
    formationEEYes: "Sí",
    formationEECurrentlyWorking: "Trabajo aquí atualmente",
    formationEELeaveDateCourse: "Fecha de Salida",
    personalAddInfo: "Formación",

    cultureDesc:
      "Completa las preguntas a continuación y nuestros algoritmos identificaran cual es tu perfil CULTURAL! Con eso vamos presentarte Empresas que te pueden hacer MATCH y podrás postular a organizaciones que estén alineadas a tu perfil.",

    //ClimeQuestionsEE
    climeQuestionsEEH1: "Muy Insatisfecho",
    climeQuestionsEEH2: "Insatisfecho",
    climeQuestionsEEH3: "Satisfecho",
    climeQuestionsEEH4: "Muy Satisfecho",
    cultureQuestionsEEForMe: "Para mi",

    //Section1
    climeQuestionsEETitle1: "RECURSOS, MEDIO AMBIENTE Y CULTURA",
    climeQuestionEE1: "¿Las relaciones personales con tus colegas son generalmente buenas?",
    climeQuestionEE2: "¿La empresa y el liderazgo brindan suficientes iniciativas, canales y entornos para fomentar las buenas relaciones con tus colegas?",
    climeQuestionEE3: "¿Cuentas con los recursos, herramientas y entornos necesarios, ya sean físicos o digitales, para llevar a cabo tus tareas y alcanzar los objetivos?",
    climeQuestionEE4: "¿Son coherentes la cultura y los valores de la empresa con tus valores personales?",
    //Section2
    climeQuestionsEETitle2: "ACTIVIDADES Y FUNCIONES REALIZADAS",
    climeQuestionEE5: "¿El volumen de trabajo realizado es adecuado para tu puesto y carga de trabajo?",
    climeQuestionEE6: "¿Tu puesto es consistente con tus habilidades, conocimientos y antigüedad profesional?",
    climeQuestionEE7: "¿Están claros sus objetivos, tareas y entregables establecidos?",
    climeQuestionEE8: "¿Son tus responsabilidades acordes con el puesto que ocupas?",
    climeQuestionEE9: "¿Tiene claridad y percepción de valor del impacto de las tareas en los objetivos de la empresa?",
    climeQuestionEE10: "¿El modelo de trabajo (presencial, híbrido o home office) es adecuado para el desempeño de tus funciones?",
    //Section2
    climeQuestionsEETitle3: "LIDERAZGO",
    climeQuestionEE11: "¿Tu líder escucha y considera tus opiniones al tomar decisiones?",
    climeQuestionEE12: "¿Es adecuada la evaluación de tu desempeño y el reconocimiento de tus contribuciones?",
    climeQuestionEE13: "Tu líder mantiene un nivel adecuado de exigencia a tu posición y carga de trabajo?",
    climeQuestionEE14: "¿Tiene tu liderazgo el conocimiento técnico, las habilidades generales y el apoyo necesarios para que usted tenga éxito en tus actividades?",
    climeQuestionEE15: "¿Te sientes cómodo compartiendo dificultades, incomodidades o pidiendo retroalimentación cuando es necesario?",
    //Section2
    climeQuestionsEETitle4: "OPORTUNIDAD Y CARRERA",
    climeQuestionEE16: "¿Hay motivaciones y desafíos en tus funciones?",
    climeQuestionEE17: "¿Hay autonomía para aplicar tus habilidades y tomar decisiones adecuadas a tu cargo?",
    climeQuestionEE18: "¿Hay posibilidad de promoción y/o plan de carrera bien claros y definidos?",
    climeQuestionEE19: "¿Hay inversión de la empresa en desarrollo de carrera?",
    climeQuestionEE20: "¿Hay espacio para expresar tus ambiciones y aplicar a posiciones dentro de la organización?",
    climeQuestionEE21: "¿Hay claridad acerca de lo que es necesario para crecer en la compañía?",

    //Section2
    climeQuestionsEETitle5: "SALARIOS Y BENEFICIOS",
    climeQuestionEE22: "¿Tu remuneración es adecuada para el cargo que ocupa y las actividades que realiza?",
    climeQuestionEE23: "¿Los beneficios satisfacen sus necesidades?",
    climeQuestionEE24: "¿Los procesos de reembolso son claros y fáciles de ejecutar?",

    //Section6
    climeQuestionsEETitle6: 'Responda las siguientes preguntas del 1 al 10, donde 1 indica "totalmente en desacuerdo" y 10 indica "totalmente de acuerdo":',
    climeQuestionEE25: "¿Recomendaría a un amigo o familiar para trabajar en esta empresa?",

    climeQuestionsAlert:
      "IMPORTANTE: Tu Empresa no tendrá acceso a tus respuestas, solamente a la media entre los colaboradores, siempre y cuando más de 10 colaboradores hayan respondido la encuesta, con el objetivo de mantener la confidencialidad.",

    culturaQuestionEE1: "Para mi es importante que exista un buen balance de hombres y mujeres en cargos gerenciales.",
    culturaQuestionEE2: "Me encanta vestirme y comportarme de manera formal en el trabajo.",
    culturaQuestionEE3: "Para mi es importante que exista reciclaje y uso inteligente de los recursos de la empresa.",
    culturaQuestionEE4: "Me gusta que exista absoluta tolerancia a la orientación sexual de mis compañeros y jefaturas.",
    culturaQuestionEE5: "Me siento más cómodo/a en una empresa innovadora que en una extremadamente tradicional.",
    culturaQuestionEE6: "Es entendible que una empresa tenga teléfonos y correos para hacer denuncias confidenciales.",

    //CultureQuestions
    cultureQuestionEE1: "Ser competitivo es clave para ser exitoso en el trabajo.",
    cultureQuestionEE2: "Si tengo que elegir entre desarrollo profesional versus sueldo, prefiero desarrollo profesional.",
    cultureQuestionEE3: "Quiero asumir cargos de más poder rápidamente.",
    cultureQuestionEE4: "Cuidar lo que dices y ser políticamente correcto al opinar, es clave para ser exitoso en el trabajo.",
    cultureQuestionEE5: "Es importante esconder los tatuajes y cuidar la apariencia física en el trabajo para ser exitoso.",
    cultureQuestionEE6: "Si mi jefe no conversa conmigo sobre mi desarrollo de carrera, lo entiendo.",
    cultureQuestionEE7: "Es entendible que los Directores o Gerentes tengan estacionamientos privilegiados.",
    cultureQuestionEE8: "Es entendible que la comunicación de los jefes pueda tornarse más dura en ocasiones.",
    cultureQuestionEE9: "Es entendible que el Gerente General sea cercano con algunas personas y con otras no.",
    cultureQuestionEE10: "El tema del liderazgo es lo más importante.",
    cultureQuestionEE11: "Si fuera parte de un equipo de alto desempeño, trabajaría hasta más tarde.",
    cultureQuestionEE12: "Me encanta que mi jefe me pregunte qué opino sobre su liderazgo y gestión.",
    cultureQuestionEE13: "Me siento más cómodo en una empresa con sindicato(s).",
    cultureQuestionEE14: "Elegir mi horario de entrada y salida, es un factor clave para mi.",
    cultureQuestionEE15: "Salir más temprano los viernes, es un factor clave para mi.",
    cultureQuestionEE16: "Tener días libres por sobre lo legal en caso de matrimonio o AUC, es un factor clave para mí.",
    cultureQuestionEE17: "Tener los mejores beneficios para las mujeres en pre y post natal, es un factor clave para mi.",
    cultureQuestionEE18: "Que la empresa apoye las actividades deportivas de los colaboradores, es un factor clave para mi.",

    contractTypeEE: "Tipo de Contracto",

    //CareerPlan
    directorCP: "Director",
    managerCP: "Gerente",
    submanagerCP: "Subgerente",
    bossCP: "Jefe",
    specialistCP: "Especialista",
    analystCP: "Analista",
    operatorCP: "Operário / Técnico / Asistente",

    //InternalJobs
    emptyInternalJobs: "Aún no hay vacantes publicadas",

    //InternalMessage
    emptyMessage: "No hay mensaje",

    //Motivations
    motivationHeaderText: " MyDNA puede ayudarte a realizar Tests de Personalidad que te ayudan a crear un plan de desarrollo de carrera. Escribinos directamente y te apoyamos!",
    motivationOption1: "Opción 1 - Mi autoevaluación de Motivaciones",
    motivationOption1Text:
      "Por favor, proporciona una calificación del 1 al 10 para cada elemento, donde 1 indica que el elemento no es un factor importante para tu motivación profesional, y 10 indica que es extremamente importante.",
    motivationInputError: "Introduzca un valor entre 1 y 10",
    motivationShowColab: "Mostrar los resultados mi autoevaluación a los reclutadores",

    motivationOption2: "Opción 2 - Evaluación de Motivaciones MyCo - Certificada por Especialistas",
    motivationOption2Text: "Por favor, proporciona una calificación del 1 al 10 para cada elemento, según los datos proporcionados en su informe Myco.",
    motivationShowMyCo: "Mostrar los resultados evaluación MyCo a los reclutadores",

    //Abilities
    abilitiesHeaderText: "MyDNA puede ayudarte a realizar Tests de Personalidad que te ayudan a crear un plan de desarrollo de carrera. Escribinos directamente y te apoyamos!",
    abilitiesOption1Text:
      "Por favor, proporciona una calificación del 1 al 10 para cada elemento, donde 1 indica que sientes que necesitas mejorar en esa competencia, y 10 indica que te consideras muy competente en ella.",
    abilitiesOption1: "Opción 1 - Mi autoevaluación de Competencias",
    abilitiesInputError: "Introduzca un valor entre 1 y 10",
    abilitiesShowColab: "Mostrar los resultados mi autoevaluación a los reclutadores",
    abilitiesOption2: "Opción 2 - Evaluación de Competencias MyCo - Certificada por Especialistas",
    abilitiesOption2Text: "Por favor, proporciona una calificación del 1 al 10 para cada elemento, según los datos proporcionados en su informe Myco.",
    abilitiesShowMyCo: "Mostrar los resultados evaluación MyCo a los reclutadores",

    quoationMotivationsAbilitiesText:
      "Conoces nuestra herramienta de evaluación brinda un entendimiento detallado de fortalezas, debilidades y oportunidades de crecimiento. Ofrece perspectivas sobre competencias, motivaciones y habilidades cognitivas. Ayuda en el automejoramiento, identificación de áreas de desarrollo y preparación para futuras entrevistas laborales.",
    downloadModel: "Descargar Modelo",
    getQuotation: "Obtener Cotización",

    //CandidateCV
    emptyValueCV: "Campo sin llenar",
    professionalExperienceCV: "Experiencia Profesional",
    formationCV: "Formación",
    purposeCV: "Proposito",
    cultureCV: "Cultura",
    knowledgeCV: "Conocimiento",
    languagesCV: "Idiomas",
    abilitiesCV: "Habilidades",
    motivationsCV: "Motivaciones",
    professionalHistoricCV: "Historico Profesional",
    functionsCV: "Funciones",
    achiviementsCV: "Logros y Conquistas",
    referencesCV: "Referencias",
    shareButtonCV: "Compartir",

    //FirstLogin
    //WelcomePage
    welcomePageTitle: "¡Bienvenido a la plataforma profesional MyDNA!",
    welcomePageText:
      "Estamos muy contentos de tenerte aquí. Soy tu Asistente Personal y voy apoyarte en este proceso. Queremos conocerte, entender quien eres, tus ambiciones y desafios!Estamos muy contentos de tenerte aquí. Soy tu Asistente Personal y para apoyarte en este proceso tenemos que conocerte entender quien eres y tua ambiciones y desafios!",
    welcomePageText2: "¿Empezamos este viaje juntos? Haz clic en `Iniciar` para comenzar.",
    welcomePageBtn: "Seguir",
    welcomePageText4: "Al rellenar toda tu información, recibiras:",

    //InfoFirstLogin
    infoFirstLoginTitle: "¿Está correcta esta información?",
    infoFirstLoginText:
      "Según tu país y área de interés, te conectaremos con empresas y reclutadores que buscan profesionales con tu perfil. Si te consideran para participar en algún proceso de selección, se pondrán en contacto contigo a través de estos medios. Asegúrate de que tus datos correctos.",
    infoFirstLoginName: "Nombre",
    infoFirstLoginEmail: "E-mail",
    infoFirstLoginPhone: "Teléfono",
    infoFirstLoginCountry: "País",
    infoFirstLoginAreas: "Áreas de Interes",
    firstLoginBtn: "Seguir",

    //Step1FirstLogin
    step1FirstLogin: "Cuéntanos sobre tu trabajo actual o último desafío.",
    step1FirstLoginText:
      "Tu último cargo y empresa son cruciales para reflejar tus competencias actuales y son de gran interés para los reclutadores al seleccionar perfiles destacados. Te recomendamos proporcionar información detallada sobre esta experiencia, lo cual te destacarán entre otros candidatos.  adelante, tendrás la oportunidad de agregar todas tus experiencias adquiridas.",
    step1Company: "Empresa *",
    step1Industry: "Industria *",
    step1Position: "Cargo *",
    step1HierarchicalLevel: "Nivel Jerarquico *",
    step1Area: "Area *",
    step1Working: "Trabaja aquí actualmente? *",
    step1StartDate: "Fecha de Ingresso *",
    step1EndDate: "Fecha de Salida *",
    step1FirstLoginBtn: "Seguir",

    //Step2FirstLogin
    step2Title: "Cuéntanos sobre tu paquete de remuneración actual: nos interesa conocer tanto tu salario fijo como el variable.",
    step2Text:
      "En MyDNA, no solo informas a los reclutadores. Más adelante, te ayudaremos a evaluar si tu salario actual está alineado con el mercado, y te apoyaremos en la alineación de tus estrategias.",
    step2FixedSalary: "Sueldo Bruto Fijo *",
    step2VariableSalary: "Sueldo Variable *",

    //Step3FirstLogin
    step3FirstLoginTitle: "Cuéntanos acerca de tu formación más relevante y tu nivel de inglés.",
    step3FirstLoginText:
      "Esta información es crucial para identificar tus habilidades y, más adelante, proporcionarte ideas valiosas para desarrollar tu carrera según tus objetivos profesionales.",
    step3Formation: "Formación",
    step3University: "Universidad *",
    step3Career: "Carrera *",
    step3Type: "Tipo *",
    step3Studing: "Cursando Actualmente? *",
    step3StartDate: "Fecha de Ingresso *",
    step3EndDate: "Fecha de Salida *",
    step3English: "Inglés",
    step3Level: "Nível *",
    step3Basic: "Basico",
    step3Intermediate: "Intermedio",
    step3Advanced: "Avanzado",
    step3Fluent: "Fluido",

    //MiniProfile
    miniProfileText1: "¡Mira cómo quedará tu perfil!",
    miniProfileText2: "¡Continúe completando para obtener la versión completa!",
    miniProfileText3:
      "Cuanta más información agregues, más atractivo será tu perfil y más fácil será encontrar vacantes perfectas para ti. Te sugerimos completar todas las secciones de la plataforma:",
    miniProfileText4: "Agregar más experiencias profesionales",
    miniProfileText5: "Realizar testes de cultura y competencias",
    miniProfileText6: "Agregar presentación y referencias",
    miniProfileText7: "Análisis e Indicaciones de Vacantes",
    miniProfileText8: "Currículum Personalizado",
    miniProfileText9: "Acceso Completo a la Plataforma",
    miniProfileText10: "¡Descubre todas las funciones y herramientas disponibles para ti!",
    miniProfileBtn: "Explorar Plataforma",
  },
};
